/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Group_Options_Create_Ad_Template_FailedInputs */

const en_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD Template creation failed. ${i?.error}`)
};

const fr_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la création du modèle de description audio. ${i?.error}`)
};

const de_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Erstellung der AD-Vorlage ist fehlgeschlagen. ${i?.error}`)
};

const it_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creazione del modello AD non riuscita. ${i?.error}`)
};

const ru_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создание шаблона объявления не удалось. ${i?.error}`)
};

const es_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la creación de la plantilla de AD. ${i?.error}`)
};

const zh_cn2_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD模板创建失败。${i?.error}`)
};

const ja_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD テンプレートの作成に失敗しました。${i?.error}`)
};

const hi_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD टेम्पलेट निर्माण विफल रहा। ${i?.error}`)
};

const pt_pt2_event_group_options_create_ad_template_failed = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A criação do modelo do AD falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "AD Template creation failed. {error}" |
*
* @param {Event_Group_Options_Create_Ad_Template_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template_failed = /** @type {((inputs: Event_Group_Options_Create_Ad_Template_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_Template_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_create_ad_template_failed(inputs)
	if (locale === "de") return de_event_group_options_create_ad_template_failed(inputs)
	if (locale === "it") return it_event_group_options_create_ad_template_failed(inputs)
	if (locale === "ru") return ru_event_group_options_create_ad_template_failed(inputs)
	if (locale === "es") return es_event_group_options_create_ad_template_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_create_ad_template_failed(inputs)
	if (locale === "ja") return ja_event_group_options_create_ad_template_failed(inputs)
	if (locale === "hi") return hi_event_group_options_create_ad_template_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_create_ad_template_failed(inputs)
	return en_event_group_options_create_ad_template_failed(inputs)
});